import Stepper  from "@/components/test/stepper.vue"
import Grid     from "@/components/test/grid.vue"
export default {
    components : {
        Stepper,
        Grid
    }
}
